import {Text} from "@fragments";


export default function Section({ icon, title, description, children }) {
    return (
        <>
            <Text.h3
                icon={icon}
                value={title}
            />

            <div className="mb-2">
                <span style={{ opacity: 0.7, marginTop: '-4px', display: 'block' }} >{description}</span>
            </div>

            {children}
        </>
    )
}

export function SectionRow({ children, className = "" }) {
    return (
        <div className={"grid grid-cols-2 gap-4 mb-2 " + className}>
            {children}
        </div>
    )
}